import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { CartSidebarComponent } from '../../../features/product-list/components/sidebar/components/cart-sidebar/cart-sidebar.component';
import { CustomizerSidebarComponent } from '../../../features/product-list/components/sidebar/components/customizer-sidebar/customizer-sidebar.component';
import { CartService, CartItem } from '../../../core/services/cart.service';
import { ApiService } from '../../../core/services/api.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TopBarComponent, CartSidebarComponent, CustomizerSidebarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  showCustomizer = false;
  customizerOptions: any[] = [];
  editingItem: CartItem | null = null;
  editImage = '';

  constructor(
    public cartService: CartService,
    private apiService: ApiService
  ) {}

  onEditPersonalization(item: CartItem): void {
    this.editingItem = item;
    this.editImage = item.image;

    // Load customization options for this product
    this.apiService.getProductCustomization(item.publicId).subscribe({
      next: res => {
        // Parse existing customization to pre-fill
        const existing: Record<string, string> = {};
        if (item.customization) {
          item.customization.split(' | ').forEach(part => {
            const [key, val] = part.split(': ');
            if (key && val) existing[key.trim()] = val.trim();
          });
        }

        this.customizerOptions = res.data.flatMap((attr: any) =>
          (attr.options ?? []).map((opt: any) => ({
            ...opt,
            selectedValue: existing[opt.value] ?? ''
          }))
        );
        this.showCustomizer = true;
      }
    });
  }

  onCustomizationSaved(data: Record<string, string>): void {
    if (!this.editingItem) return;
    const parts: string[] = [];
    for (const [key, val] of Object.entries(data)) {
      if (val) parts.push(`${key}: ${val}`);
    }
    const customization = parts.length > 0 ? parts.join(' | ') : '';
    this.cartService.updateCustomization(this.editingItem.cartId, customization);

    // Update orderTextAttrs with new values
    const updatedTextAttrs = this.customizerOptions
      .filter((opt: any) => opt.selectedValue && opt.selectedValue !== 'No')
      .map((opt: any) => ({
        optionId: Number(opt.id),
        name: opt.value,
        inputType: opt.inputType,
        value: opt.selectedValue,
      }));

    const items = this.cartService.items();
    const item = items.find(i => i.cartId === this.editingItem!.cartId);
    if (item) {
      item.orderTextAttrs = updatedTextAttrs;
      this.cartService.items.set([...items]);
    }

    this.showCustomizer = false;
    this.editingItem = null;
  }
}
